import script from "./ApproverList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApproverList.vue?vue&type=script&setup=true&lang=js"

import "./ApproverList.vue?vue&type=style&index=0&id=70c58ea3&lang=css"

const __exports__ = script;

export default __exports__